import {
  BarcodeQuestionConfig,
  BarcodeResponseState,
} from '@gripp/shared-logic';
import { RoutineQuestionModule } from '../types';
import { BarcodeQuestionAdminForm } from './barcodeQuestionAdminForm';
import { BarcodeQuestionExecutionForm } from './barcodeQuestionExecutionForm';
import { BarcodeQuestionMessage } from './barcodeQuestionMessage';

export const BarcodeQuestionModule: RoutineQuestionModule<
  BarcodeQuestionConfig,
  BarcodeResponseState
> = {
  adminForm: BarcodeQuestionAdminForm,
  executionForm: BarcodeQuestionExecutionForm,
  message: BarcodeQuestionMessage,
};
